import { useEffect, useState } from "react";

const API = process.env.REACT_APP_BACKEND_URL;
const CACHE_KEY = "klc:popular_treatments_banner_enabled";
const CACHE_TTL_MS = 60_000; // 1 minute

/**
 * Cached public flag — is the homepage "Popular Treatments Scrolling Banner"
 * automation enabled? Toggled from Head Office → Automations. Defaults TRUE
 * so the banner shows unless Karine explicitly turns it off.
 */
export function usePopularTreatmentsBannerEnabled() {
  // Optimistic default: show the banner. If the backend later says
  // "disabled", we hide it then.
  const [enabled, setEnabled] = useState(true);

  useEffect(() => {
    let cancelled = false;
    try {
      const raw = sessionStorage.getItem(CACHE_KEY);
      if (raw) {
        const parsed = JSON.parse(raw);
        if (parsed && parsed.ts && Date.now() - parsed.ts < CACHE_TTL_MS) {
          setEnabled(!!parsed.enabled);
          return undefined;
        }
      }
    } catch (_e) { /* sessionStorage may be blocked — ignore */ }

    fetch(`${API}/api/ui/popular-treatments-banner`, { credentials: "omit" })
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => {
        if (cancelled || !data) return;
        const next = !!data.enabled;
        setEnabled(next);
        try {
          sessionStorage.setItem(
            CACHE_KEY,
            JSON.stringify({ enabled: next, ts: Date.now() })
          );
        } catch (_e) { /* ignore */ }
      })
      .catch(() => { /* keep optimistic default on error */ });

    return () => { cancelled = true; };
  }, []);

  return enabled;
}

export default usePopularTreatmentsBannerEnabled;
